import UserProfileContainer from './user-profile-container';

export default UserProfileContainer;
